import _ from 'lodash';
import {
  INDEX_INSTRUMENTS_ONLY_WEEKLY_EXPIRY,
  MONTHLY_ONLY_INDEX, ILL_IQUID_INDEX,
  WEEKLY_EXPIRY_INSTRUMENTS
} from 'v2/common/constants/index';

export const isIndexInstrumentPresentInInstrumentGroup = (instrumentGroups, instrumentIndex = 0) => {
  const { indexInstruments } = window;

  return _.some(instrumentGroups, (instrumentGroup) => {
    return _.includes(indexInstruments, _.get(instrumentGroup, instrumentIndex, ''));
  });
};

export const isIndexInstrumentWithWeeklyExpiryOnly = (instrumentGroups, instrumentIndex = 0) => {
  const isIndexInstrument = isIndexInstrumentPresentInInstrumentGroup(instrumentGroups, instrumentIndex);
  return isIndexInstrument && _.some(instrumentGroups, (instrumentGroup) => {
    return _.includes(INDEX_INSTRUMENTS_ONLY_WEEKLY_EXPIRY, _.get(instrumentGroup, instrumentIndex, ''));
  });
};

export const isWeeklySupportedIndexInstrument = (instrumentGroups, instrumentIndex = 0) => {
  const isIndexInstrument = isIndexInstrumentPresentInInstrumentGroup(instrumentGroups, instrumentIndex);
  return isIndexInstrument && _.some(instrumentGroups, (instrumentGroup) => {
    return !_.includes(MONTHLY_ONLY_INDEX, _.get(instrumentGroup, instrumentIndex, ''));
  });
};
export const isIlliquidInstrument = (instrumentGroups, instrumentIndex = 0) => {
  return _.some(instrumentGroups, (instrumentGroup) => {
    return _.includes(ILL_IQUID_INDEX, _.get(instrumentGroup, instrumentIndex, ''));
  });
};

export const isWeeklyExpiry = (instrumentGroups = [], instrumentIndex = 0) =>
  instrumentGroups.every((group) => {
    const instrument = group[instrumentIndex];
    return instrument ? WEEKLY_EXPIRY_INSTRUMENTS.includes(instrument) : true;
  });
